import { RootState } from '@/redux/store';

export const selectOrganizationHasAddOn =
  (name: string) =>
  (state: RootState): boolean => {
    return (
      state.loggedUser?.organizationAddOns?.some(
        addOn => addOn.name === name
      ) ?? false
    );
  };
